module.exports = __webpack_public_path__ + "img/omgo_pangsky_foot.24f90088.png";